export interface DividerProps {
  /** Additional styles to apply to the divider. */
  style?: React.CSSProperties;
}

/**
 * A small horizontal divider line used to separate sections of the home page.
 */
export function Divider({ style }: DividerProps) {
  return (
    <div
      style={{
        width: "75%",
        marginTop: 20,
        marginBottom: 20,
        maxWidth: 400,
        backgroundColor: "gray",
        height: 1,
        borderRadius: 2,
        ...style,
      }}
    />
  );
}
